import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-tmc-bg" data-testid="auth-loading">
                <div className="flex items-center gap-3 text-tmc-muted">
                    <div className="w-2 h-2 rounded-full bg-tmc-terracotta animate-soft-pulse" />
                    <span className="font-serif italic">Signing you in…</span>
                </div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    }
    if (requireAdmin && user.role !== "admin") {
        return <Navigate to="/vote" replace />;
    }
    return children;
}
